import Link from "next/link";
import { Languages } from "@/components/icons";

interface Props {
  href: string;
  hrefLang: string;
  label: string;
}

/** Small, crawlable cross-language link rendered on each localized page and
 *  its English counterpart. Deliberately a plain anchor (not JS-driven) so
 *  Googlebot can follow it to discover the alternate-language version, per
 *  Google's multi-regional-site guidance. Positioned to float over the hero
 *  rather than taking its own layout row, since these pages aren't part of a
 *  site-wide locale switcher yet. */
export function LanguageSwitchLink({ href, hrefLang, label }: Props) {
  return (
    <div className="absolute top-20 right-4 z-40 sm:top-24 sm:right-6 lg:right-8">
      <Link
        href={href}
        hrefLang={hrefLang}
        className="border-border bg-background/80 text-muted-foreground hover:text-foreground hover:border-foreground/30 inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium backdrop-blur transition-colors"
      >
        <Languages size={14} aria-hidden="true" />
        {label}
      </Link>
    </div>
  );
}
